/**
 * I18n constants
 */
export const SUPPORTED_LANGUAGES = ['en', 'es', 'fr', 'de', 'pt-BR'];
export const LANGUAGE_NAMES = {
    en: 'English',
    es: 'Español',
    fr: 'Français',
    de: 'Deutsch',
    'pt-BR': 'Português',
};
export const DEFAULT_LANGUAGE = 'en';
export const NAMESPACES = [
    'common',
    'dashboard',
    'onboarding',
    'settings',
    'profile',
    'nav',
    'engineers',
    'teams',
    'workItems',
    'repositories',
    'pullRequests',
    'leaderboard',
    'layout',
    'govern',
    'inspect',
];
export const DEFAULT_NAMESPACE = 'common';
export const FALLBACK_LANGUAGE = 'en';
//# sourceMappingURL=i18n.js.map